<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Maintenance Record - Form
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Workorder Number</label></b-input-group-prepend>
                <b-form-input v-model="model.maintSpkNo" :state="!$v.model.maintSpkKey.$error" readonly></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuSpkShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-append><span class="input-group-text">Maintenance Date</span></b-input-group-append>
                <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Maintenance Title</label></b-input-group-prepend>
            <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error" placeholder="Maintenance Name/Title"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
            <b-form-input v-model="model.asetid" readonly class="mr-1" :state="!$v.model.asetkey.$error"></b-form-input>
            <b-form-input v-model="model.asdesc" readonly style="width: 45% !important" :state="!$v.model.asetkey.$error"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>FA Category</label></b-input-group-prepend>
                <b-form-input v-model="model.catgname" readonly></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                <b-form-input v-model="model.asmodel" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-input-group>
            <b-input-group-prepend><label>Maintenance by</label></b-input-group-prepend>
            <!-- <b-form-radio-group  v-model="model.internal" class="ml-2 mt-1">
                            <b-form-radio :value="1">Internal</b-form-radio>
                            <b-form-radio :value="0">Vendor</b-form-radio>
                        </b-form-radio-group>                   -->
            <b-input-group-prepend>
              <b-form-select style="width: 110px; margin-right: 2px" v-model="model.internal" :plain="true" :options="InterExtern" disabled></b-form-select>
            </b-input-group-prepend>
            <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor_id.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuVendorShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <h4>DIMENSION</h4>
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
        </b-col>
      </b-row>

      <b-card no-body class="mb-1">
        <b-table
          class="mb-0"
          ref="tblApLines"
          outlined
          striped
          hover
          small
          style="font-size: smaller"
          :items="apLines.items"
          :fields="apLines.fields"
          :current-page="apLines.page"
          :per-page="apLines.limit"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(jasa)="data">
            <span v-if="data.item.jasa == 1">Jasa</span>
            <span v-else>Material</span>
          </template>
          <template v-slot:cell(quantity)="data"> {{ data.item.quantity }} {{ data.item.unitsize }} </template>
          <template v-slot:cell(unitprice)="data">
            {{ data.item.unitprice | numFormat }}
          </template>
          <template v-slot:cell(nilai)="data">
            {{ data.item.nilai | numFormat }}
          </template>
          <template v-slot:cell(nilaippn)="data">
            {{ data.item.nilaippn | numFormat }}
          </template>
          <template v-slot:cell(nilaidue)="data">
            {{ data.item.nilaidue | numFormat }}
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editApLines(data.item, data.toggleDetails)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click="delApLines(data.index)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card class="row-details-form">
              <b-row>
                <b-col lg="8">
                  <b-input-group>
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="apLinesObj.uraian_dt"></b-form-input>
                    <b-form-radio-group v-model="apLinesObj.jasa" name="radioJasa" class="ml-2 mt-1">
                      <b-form-radio :value="0">Material/Part</b-form-radio>
                      <b-form-radio :value="1">Jasa/Service</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
                  <b-row>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                        <b-form-input v-model="apLinesObj.quantity" @change="calcPrice()" type="number"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text" style="width: 70px">Unit Size</span></b-input-group-prepend>
                        <b-form-input v-model="apLinesObj.unitsize"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Unit Price</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apLinesObj.unitprice" :precision="2" :state="!$v.apLinesObj.unitprice.$error"></my-number>
                        <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="apLinesObj.kenappn" value="1" unchecked-value="0" @change="calcTaxes()">PPN (VAT In)</b-form-checkbox>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apLinesObj.nilai" :precision="2" disabled></my-number>
                      </b-input-group>
                    </b-col>
                    <b-col lg="6">
                      <b-input-group v-if="apLinesObj.kenappn === 1">
                        <b-input-group-prepend><label style="width: 158px !important">Nilai DPP</label></b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apLinesObj.dpp" :precision="2" style="width: 30% !important"></my-number>
                        <b-input-group-prepend><span class="ml-1 pt-2 mr-1">tarif</span></b-input-group-prepend>
                        <b-form-input v-model="apLinesObj.dppnlain" type="number" @change="calcTaxes()"></b-form-input>
                        <b-input-group-append><span class="pt-2">% * NetAmount</span></b-input-group-append>
                      </b-input-group>
                      <hr v-else />

                      <b-input-group>
                        <b-input-group-prepend><label style="width: 158px !important">PPH akan dipotong</label></b-input-group-prepend>
                        <b-form-select v-model="apLinesObj.pasalpph" :plain="true" :options="lookupPPH" :state="!$v.apLinesObj.pasalpph.$error" style="width: 30% !important"></b-form-select>
                        <b-input-group-prepend><span class="input-group-text">tarif</span></b-input-group-prepend>
                        <!-- <b-input-group-prepend><span class="ml-1 pt-2 mr-1">tarif</span></b-input-group-prepend> -->
                        <b-form-input v-model="apLinesObj.pph" type="number" @change="calcTaxes()"></b-form-input>
                        <b-input-group-append><span class="pt-2">% * Nilai DPP</span></b-input-group-append>
                        <!-- <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append> -->
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-select style="width: 158px; font-size: 0.75rem" v-model="calcPPh" :plain="true" :options="calcuationPPH"></b-form-select>
                        </b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apLinesObj.nilaipph" :precision="2" :readonly="calcPPh === 1"></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="4">
                  <v-dim :model="apLinesObj" :key="updateDimDtl" :horizontal="true"></v-dim>
                </b-col>
              </b-row>
              <b-row class="justify-content-center mt-1">
                <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveApLines()">Update</b-button>
                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-row class="mt-1">
          <b-col cols="5">
            <b-row>
              <b-button size="sm" class="ml-3" @click="addApLines" :disabled="!model.maintSpkKey">Add Detail</b-button>
              <div class="ml-2">
                Showing {{ (apLines.page - 1) * apLines.limit + 1 }} to <span v-if="apLines.page * apLines.limit > apLines.total">{{ apLines.total }}</span>
                <span v-else>{{ apLines.page * apLines.limit }}</span>
                <strong> of {{ apLines.total }} entries </strong>
              </div>
            </b-row>
          </b-col>
          <b-col cols="2">
            <b-input-group>
              <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
              <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="apLines.limit" style="width: 80px" />
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-pagination align="right" :total-rows="apLines.total" :per-page="apLines.limit" v-model="apLines.page"></b-pagination>
          </b-col>
        </b-row>
      </b-card>

      <b-row align-h="between" class="mt-1">
        <b-col lg="8" xl="7">
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend><label>Nomor Invoice</label></b-input-group-prepend>
                <b-form-input v-model="model.invoice" :state="!$v.model.invoice.$error"></b-form-input>
                <b-form-radio-group v-model="model.internal" class="ml-2 mt-1" disabled>
                  <b-form-radio :value="0">Vendor/External</b-form-radio>
                  <b-form-radio :value="1">Internal</b-form-radio>
                </b-form-radio-group>
              </b-input-group>
            </b-col>
          </b-row>
          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                <b-form-input v-model="model.nofaktur" :state="!$v.model.nofaktur.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label style="width: 70px">Tgl. Faktur</label></b-input-group-prepend>
                <b-form-input v-model="model.tglfaktur" type="date" :state="!$v.model.tglfaktur.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                </b-input-group-prepend>
                <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Kurs Pajak {{ model.matauang }}</label></b-input-group-prepend
                >
                <my-number :disabled="model.matauang === uanguser" class="form-control text-right" separator="," v-model="model.kursppn"></my-number>
              </b-input-group>
            </b-col>
          </b-form-row>
        </b-col>
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">subtotal</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-form-select style="width: 158px; font-size: 0.75rem" v-model="calcVAT" :plain="true" :options="calcuationVAT"></b-form-select>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="calcVAT === 1"></my-number>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Total Invoice</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
        <button class="btn btn-primary" @click="close()"><i class="fa fa-close"></i> Close</button>
      </b-row>
    </b-card>
    <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
      <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
    </b-modal>
    <b-modal v-model="lkuSpkShow" size="lg" :hide-footer="true" title="List of Maintenance Workorder" :centered="true">
      <lku-workorder @click="onSelectLkuSpk"></lku-workorder>
    </b-modal>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuVendor from "../lookup/lkuVendor";
import lkuWorkorder from "../lookup/lkuMaintenspk";
import workorder from "../../apis/maintenworko";
import mtcrecord from "../../apis/maintenrec";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric, minValue, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, vDim, lkuVendor, lkuWorkorder },
  mixins: [validationMixin],
  validations: {
    model: {
      asetkey: { required },
      maintSpkKey: { required },
      tanggal: { required },
      vendor_id: {
        required: function () {
          if ((this.model.internal || 0) == 0) {
            return true;
          } else if (!this.model.vendor_id) {
            return false;
          } else return true;
        },
      },
      uraian: { required },
      invoice: {
        required: function () {
          if ((this.model.internal || 0) == 1) {
            return true;
          } else if ((this.model.invoice || "") == "") {
            return false;
          } else return true;
        },
      },
      nofaktur: {
        required: function () {
          if ((this.model.nilaippn || 0) == 0) {
            return true;
          } else if ((this.model.nofaktur || "") == "") {
            return false;
          } else return true;
        },
      },
      tglfaktur: {
        required: function () {
          if ((this.model.nilaippn || 0) == 0) {
            return true;
          } else if (!this.model.tglfaktur) {
            return false;
          } else return true;
        },
      },
      totalinv: { required, minValue: minValue(1) },
      ratekurs: { required, minValue: minValue(0.00000001) },
    },
    apLinesObj: {
      kodeacc: { required },
      uraian_dt: { required },
      jasa: { required },
      quantity: { numeric },
      unitprice: { numeric },
      nilai: { numeric },
      // ppn: { numeric },
      kenappn: { required },
      pasalpph: {
        required: function () {
          if ((this.apLinesObj.nilaipph || 0) == 0) {
            return true;
          } else if ((this.apLinesObj.pasalpph || "") == "" || this.apLinesObj.pasalpph == "N/A" || this.apLinesObj.pasalpph == "NO WHT") {
            return false;
          } else return true;
        },
      },
    },
  },
  data() {
    return {
      saveEnabled: true,
      lkuSpkShow: false,
      lkuVendorShow: false,
      updateDimHdr: false,
      updateDimDtl: true,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      calcVAT: 1,
      calcuationVAT: [
        { value: 1, text: "VAT (Auto Calc)" },
        { value: 0, text: "VAT (Manual Calc)" },
      ],
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      InterExtern: [
        { value: 0, text: "Vendor" },
        { value: 1, text: "Internal" },
      ],
      lookupPPH: [],
      model: {
        asetKey: 0,
        vendor_id: "",
        internal: 0,
        maintSpkNo: "",
        maintSpkKey: "",
        uraian: "",
        tanggal: moment().format("YYYY-MM-DD"),
        postgroup: "",
        kodecash: "",
        matauang: "IDR",
        tagihandp: 0,
        termin: "",
        nofaktur: "",
        tglfaktur: "",
        totalinv: 0,
        nilaippn: 0,
        grossup: 0,
        ratekurs: 1,
        kursppn: 1,
        DimTableKey: "",
      },
      apLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "uraian_dt",
            label: "Description",
          },
          {
            key: "jasa",
            label: "",
          },
          {
            key: "glAccount",
            label: "GL Account",
          },
          {
            key: "quantity",
            label: "Quantity",
            thStyle: "width:90px",
          },
          {
            key: "unitprice",
            label: "Unit price",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilai",
            label: "Amount NETT",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaippn",
            label: "VAT",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidue",
            label: "Amount DUE",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 15,
        total: 0,
      },
      apLinesObj: {
        kodeacc: "",
        uraian_dt: "",
        jasa: 1,
        quantity: 0,
        unitprice: 0,
        nilai: 0,
        ppn: 0,
        kenappn: "",
        pasalpph: "NO WHT",
        pph: 0,
        unitzise: "",
        DimTableKey: "",
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidApLines() {
      this.$v.apLinesObj.$touch();
      return this.$v.apLinesObj.$invalid;
    },
  },
  watch: {
    "model.internal": function (newval) {
      if (newval === 1) {
        this.model.vendorinfo = this.model.departname;
      } else {
        this.model.vendorinfo = this.model.vendor;
      }
    },
    "apLinesObj.unitprice": function (newval) {
      setTimeout(() => {
        this.calcPrice();
      }, 100);
    },
    "apLinesObj.pasalpph": function (newval) {
      const item = this.lookupPPH.find((p) => p.value == newval);
      if (item) {
        this.apLinesObj.pph = item.pph;
        setTimeout(() => {
          this.calcTaxes();
        }, 100);
      }
    },
  },
  created: async function () {
    if (this.$route.params.maintTrxKey) {
      toastr.info("Loading Maintenance Detail, please wait");
      try {
        const [b, data] = await Promise.all([mtcrecord.pasalpph(), mtcrecord.detail(this.$route.params)]);
        this.lookupPPH = b;

        const row = data[0][0];
        this.saveEnabled = (row.status || 0) === 0;
        row.tanggal = row.tanggal ? moment(row.tanggal).format("YYYY-MM-DD") : "";
        row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.model.vendorinfo = row.internal === 1 ? row.departname : row.vendorinfo;

        this.tanggalBerubah();
        this.updateDimHdr = !this.updateDimHdr;
        this.apLines.items = data[1];
        this.calcTotalDtlAp();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.model.tanggal = moment().format("YYYY-MM-DD");
      const [b] = await Promise.all([mtcrecord.pasalpph()]);
      this.lookupPPH = b;
    }
  },
  methods: {
    // onSelectLkuCoa(_selected) {
    //     this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
    //     this.apLinesObj.kodeacc = _selected.kodeacc;
    //     this.apLinesObj.namaacc = _selected.namaacc;
    //     this.lkuCoaShow=false;
    // },
    closeApLines: function () {
      const opened = this.apLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addApLines: function () {
      this.closeApLines();
      const obj = { _showDetails: true };
      this.apLines.selected = obj;
      for (var key in this.apLinesObj) {
        this.apLinesObj[key] = "";
      }
      this.apLinesObj.kodeacc = this.model.maintenacc;
      this.apLinesObj.glAccount = this.model.maintenAccount;
      this.apLinesObj.jasa = 1;
      this.apLinesObj.unitsize = "EACH";
      this.apLinesObj.quantity = 1;
      this.apLinesObj.kenappn = 1;
      this.apLinesObj.dppnlain = 100;
      this.apLinesObj.ppn = 10;
      this.apLinesObj.unitprice = 0;
      (this.apLinesObj.pasalpph = "N/A"), (this.apLinesObj.pph = 0);
      this.updateDimHdr2Dtl(this.apLinesObj);
      this.apLines.items.push(obj);
      this.apLines.total = this.apLines.items.length;
    },
    editApLines: function (obj, callback) {
      this.closeApLines();
      this.apLines.selected = obj;
      for (var key in this.apLinesObj) {
        this.apLinesObj[key] = "";
      }
      for (var key in obj) {
        this.apLinesObj[key] = obj[key];
      }
      this.apLinesObj.ppn = this.apLinesObj.ppn || 10;
      this.apLinesObj.pph = this.apLinesObj.pph || 0;
      this.apLinesObj.dppnlain = this.apLinesObj.dppnlain || 100;
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.apLinesObj[dim.value] = obj[dim.value];
          this.apLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.apLinesObj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      callback();
    },
    delApLines: function (index) {
      if (index > -1) {
        this.apLines.items.splice(index, 1);
      }
      this.apLines.total = this.apLines.items.length;
      this.calcTotalDtlAp();
    },
    saveApLines: async function (callback) {
      this.apLinesObj.nilainett = parseFloat(this.apLinesObj.nilai);
      if (this.apLinesObj.kenappn == 1) {
        this.apLinesObj.dpp = (parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlain)) / 100;
        // this.apLinesObj.ppn = 10;
      } else {
        this.apLinesObj.dpp = 0;
        this.apLinesObj.ppn = 0;
      }
      this.apLinesObj.nilaippn = 0.1 * this.apLinesObj.dpp;
      this.apLinesObj.nilaidue = this.apLinesObj.nilainett + this.apLinesObj.nilaippn;
      if (this.calcPPh == 1) this.apLinesObj.nilaipph = (this.apLinesObj.dpp * this.apLinesObj.pph) / 100;
      if (this.invalidApLines) {
        if (this.$v.apLinesObj.kodeacc.$anyError === true) {
          toastr.error(`Maintenance Cost/Expense Account untuk ${this.model.catgname} belum diseting, hubungi bag. Accounting`, "Fixed Asset Category");
        } else {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        }
      } else {
        let datadim = this.apLinesObj;
        datadim.TableName = "maintenance_history_line";
        try {
          const dimValResult = await dimension.validate(datadim);
          if (dimValResult.success) {
            for (var key in this.apLinesObj) {
              this.apLines.selected[key] = this.apLinesObj[key];
            }
            this.dimension.forEach((dim) => {
              if (datadim[dim.value]) {
                this.apLines.selected[dim.value] = datadim[dim.value];
                this.apLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
              }
            });
            this.apLines.total = this.apLines.items.length;
            this.updateDimDtl2Hdr(datadim);
            this.calcTotalDtlAp();
            this.apLines.selected._showDetails = false;
            if (callback) callback();
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message;
            if (callback) callback(new Error(msg));
            else {
              toastr.error(msg, "ERROR MESSAGE", 10000);
            }
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      this.model.totalinv = this.model.ttlamtdue;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.model.TableName = "maintenance_spk";
          const dimValResult = await dimension.validate(this.model);
          if (dimValResult.success) {
            // this.model.DimTableKey = diisi dari PR/SR;
            this.model.maintTrxKey = this.model.maintTrxKey || "";
            this.model.maintSpkNo = this.model.maintSpkNo || "";
            const row = {};
            for (var key in this.model) {
              row[key] = this.model[key];
            }
            row.inspMstrKey = this.model.manualKey;
            row.tanggal = moment(row.tanggal).format("YYYY-MM-DD");
            row.vendor_id = row.internal === 1 ? "" : row.vendor_id;
            let lineno = 1;
            let newApLines = this.apLines.items.reduce((newArr, item) => {
              if ((item.kodeacc || "") != "" && item.nilai) {
                item.urutan = lineno;
                newArr.push(item);
                lineno += 1;
              }
              return newArr;
            }, []);

            row.lines = newApLines;

            await mtcrecord.save(row);
            toastr.success("Complete successfully", "Save Order");
            this.close();
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message || "Dimension validation error";
            toastr.error(msg, "ERROR MESSAGE");
            this.saveEnabled = true;
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    onSelectLkuSpk: async function (_selected) {
      if (!_selected.maintenacc) {
        toastr.error(`Maintenance Cost/Expense Account untuk ${_selected.catgname} belum diseting, hubungi bag. Accounting`, "Fixed Asset Category");
      } else {
        this.lkuSpkShow = false;
        this.updateDimHdr = !this.updateDimHdr;
        for (var key in _selected) {
          this.model[key] = _selected[key];
        }
        this.model.uraian = _selected.inspectName;
        this.model.vendor = _selected.vendorinfo;
      }
    },
    onSelectLkuVendor: async function (_selected) {
      this.model.vendorinfo = _selected.vendor_name.trim() + " | " + _selected.vendor_code.trim();
      this.model.vendor = _selected.vendor_code;
      this.model.vendor_id = _selected.vendor_id;
      this.lkuVendorShow = false;
    },
    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.ordLinesObj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    tanggalBerubah: function () {
      this.tahun = moment(this.model.tanggal).format("YYYY");
    },
    calcPrice: function () {
      this.apLinesObj.nilai = parseFloat(this.apLinesObj.quantity) * parseFloat(this.apLinesObj.unitprice || 0);
      this.calcTaxes();
    },
    calcTaxes: function () {
      this.apLinesObj.dppnlain = this.apLinesObj.dppnlain || 100;
      this.apLinesObj.nilainett = this.apLinesObj.nilai;
      this.apLinesObj.dpp = (parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlain)) / 100;
      if (this.apLinesObj.kenappn == 1) {
        this.model.grossup = 0;
        this.apLinesObj.ppn = this.apLinesObj.ppn || 10;
      } else {
        this.apLinesObj.dpp = 0;
        this.apLinesObj.ppn = 0;
      }
      if (this.model.grossup == 1) this.apLinesObj.dpp = this.apLinesObj.dpp * (100 / (100 - this.apLinesObj.pph));

      this.apLinesObj.nilaippn = (this.apLinesObj.ppn / 100) * this.apLinesObj.dpp;
      this.apLinesObj.nilaidue = this.apLinesObj.nilainett + this.apLinesObj.nilaippn;
      if (this.calcPPh == 1) this.apLinesObj.nilaipph = (this.apLinesObj.dpp * parseFloat(this.apLinesObj.pph)) / 100;
    },
    calcTotalDtlAp: function () {
      this.apLines.total = this.apLines.items.length;
      this.calcVAT = this.calcVAT || 1;
      let nilaippn = 0;
      let ttlnetto = 0;
      let ttlamtdue = 0;
      let totalpph = 0;
      this.apLines.items.forEach((trx) => {
        if (trx.kodeacc) {
          ttlnetto += trx.nilai || 0;
          nilaippn += trx.nilaippn || 0;
          ttlamtdue = ttlnetto + (nilaippn || 0);
          totalpph += parseFloat(trx.nilaipph || 0);
        }
      });
      this.model.ttlnetto = ttlnetto;
      if (this.calcVAT == 1) {
        this.model.nilaippn = nilaippn;
      }
      this.model.ttlamtdue = ttlamtdue;
      this.model.totalpph = totalpph;
    },
    calcAmountDue: function () {
      this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
    },

    close() {
      if (this.$store.state.prevRoute.name && this.$store.state.prevRoute.name !== "fixedasset.maintworkorderfrm") {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push("home");
      }
    },
  },
};
</script>
